import {
    TypedUseSelectorHook,
    useDispatch as useDispatchRaw,
    useSelector as useSelectorRaw
} from 'react-redux';
import type { RootStateType, DispatchType } from './index';

export const useDispatch = () => useDispatchRaw<DispatchType>();
export const useSelector: TypedUseSelectorHook<RootStateType> = useSelectorRaw;
